import React from 'react';

import { ContextMenu } from '../../../context-menu';
import { contextMenuService } from '../../../context-menu/context-menu-service';

export type BlueprintSvgContextMenuWrapperProps = {
	svgRef: React.RefObject<SVGSVGElement>;
	children: React.ReactElement;
};

/**
 * Registers the SVG with the context-menu service on mouse enter and right-click.
 * Uses the service singleton directly (not via the hook) so this wrapper does not
 * subscribe to service state changes — which would cause every page to re-render
 * whenever any other page registers its SVG.
 */
export const BlueprintSvgContextMenuWrapper = (props: BlueprintSvgContextMenuWrapperProps): React.ReactElement => {
	const { svgRef, children } = props;

	const registerSvg = (): void => {
		if (svgRef.current) {
			contextMenuService.setSvg(svgRef.current);
		}
	};

	return (
		<div
			onMouseEnter={registerSvg}
			onContextMenu={registerSvg}
			style={{ width: '100%', height: '100%' }}
		>
			<ContextMenu svg={svgRef}>
				{children}
			</ContextMenu>
		</div>
	);
};
